// @flow
// スタッフ認証系のredux関連ソース
// state + reducers + actions

import { localStorageSetStaffLoginInfo } from "../constants/Localstorage"


export interface テーブル詳細変更理由要求 {
  伝票番号: string,
  テーブル名: string,
  処理種別: string,
  変更前内容: string,
  変更後内容: string,
}

export interface StaffLoginInfo {
  staffName: string,
  positionName: string,
  expiredAt: number,
}

export interface StaffAuthState {
  isStaffAuthModalOpen: boolean,
  isStaffOperationReasonModalOpen: boolean,
  要認証処理List: string[],
  oneTime: boolean, // 最後の403APIレスポンスで上書きされるが、保持なし型権限チェックと保持型権限チェックが混ざることは想定外
  テーブル詳細変更理由要求: テーブル詳細変更理由要求 | null,
  テーブル詳細変更理由: string,
  callbacks:  (() => void)[],
  staffLoginInfo: StaffLoginInfo | null,
}

const StaffAuthStateZero = {
  isStaffAuthModalOpen: false,
  isStaffOperationReasonModalOpen: false,
  要認証処理List: [],
  oneTime: false,
  テーブル詳細変更理由要求: null,
  テーブル詳細変更理由: '',
  callbacks: [],
  staffLoginInfo: null,
}

export interface StaffAuthOpenActionPayload {
  要認証処理List: string[],
  oneTime: boolean,
  テーブル詳細変更理由要求: テーブル詳細変更理由要求 | null,
  callback?: () => void,
}

export interface StaffAuthSetReasonPayload {
  テーブル詳細変更理由: string,
}

export interface StaffAuthSetStaffLoginInfoPayload {
  value: string,
}

export interface StaffAuthAction {
  type: string,
  payload: undefined | StaffAuthOpenActionPayload | StaffAuthSetReasonPayload,
}

const STAFF_AUTH_ACTION_TYPE = {
  OPEN : 'OPEN',
  CLOSE : 'CLOSE',
  SET_REASON : 'SET_REASON',
  SET_STAFF_LOGIN_INFO : 'SET_STAFF_LOGIN_INFO',
}

export const StaffAuthActions = {
  open: (payload: StaffAuthOpenActionPayload) => ({ type: STAFF_AUTH_ACTION_TYPE.OPEN, payload: payload }),
  setReason: (payload: StaffAuthSetReasonPayload) => ({ type: STAFF_AUTH_ACTION_TYPE.SET_REASON, payload: payload }),
  setStaffLoginInfo: (payload: StaffAuthSetStaffLoginInfoPayload) => ({ type: STAFF_AUTH_ACTION_TYPE.SET_STAFF_LOGIN_INFO, payload: payload }),
  close: { type: STAFF_AUTH_ACTION_TYPE.CLOSE },
}

const initialState = StaffAuthStateZero
export function staffAuthReducer(state: StaffAuthState = initialState, action: StaffAuthAction): StaffAuthState {
  switch (action.type) {
    case STAFF_AUTH_ACTION_TYPE.OPEN: return open(state, action.payload)
    case STAFF_AUTH_ACTION_TYPE.SET_REASON: return setReason(state, action.payload)
    case STAFF_AUTH_ACTION_TYPE.CLOSE: return close(state)
    case STAFF_AUTH_ACTION_TYPE.SET_STAFF_LOGIN_INFO: return setStaffLoginInfo(state, action.payload)
    default: return state
  }
}

const open = (state: StaffAuthState, payload: StaffAuthOpenActionPayload): StaffAuthState => {
  // 同時に発生する複数の要認証APIリクエストを一度のスタッフログインで処理するため、要認証処理Listは結合、callbackは配列で持つ
  const 要認証処理List = Array.from(new Set(state.要認証処理List.concat(payload.要認証処理List)));
  state.callbacks.push(payload.callback)
  if(!!payload.テーブル詳細変更理由要求) {
    return {
      ...state,
      isStaffOperationReasonModalOpen: true,
      oneTime: payload.oneTime,
      テーブル詳細変更理由要求: payload.テーブル詳細変更理由要求,
      要認証処理List: 要認証処理List,
    }
  }else{
    return {
      ...state,
      isStaffAuthModalOpen: true,
      oneTime: payload.oneTime,
      要認証処理List: 要認証処理List,
    }
  }

}

const setReason = (state: StaffAuthState, payload: StaffAuthSetReasonPayload): StaffAuthState => {
  return {
    ...state,
    isStaffOperationReasonModalOpen: false,
    isStaffAuthModalOpen: true,
    テーブル詳細変更理由: payload.テーブル詳細変更理由,
  }
}

const close = (state: StaffAuthState): StaffAuthState => {
  return {
    ...state,
    isStaffAuthModalOpen: false,
    isStaffOperationReasonModalOpen: false,
    要認証処理List: [],
    テーブル詳細変更理由要求: null,
    テーブル詳細変更理由: '',
    callbacks: []
  }
}

const setStaffLoginInfo = (state: StaffAuthState, payload: StaffAuthSetStaffLoginInfoPayload) : StaffAuthState => {
  let staffLoginInfo = null;
  const encoded = payload.value
  if (encoded) {
    try {
      const binary = atob(encoded);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < bytes.length; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      const json = new TextDecoder("utf-8").decode(new Uint8Array(bytes.buffer));
      staffLoginInfo = JSON.parse(json)
      localStorageSetStaffLoginInfo(encoded)
    } catch (error) {
      console.error(error)
    }
  }

  if (!staffLoginInfo) localStorageSetStaffLoginInfo('')

  return {
    ...state,
    staffLoginInfo: staffLoginInfo,
  }
}